"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.buttonTextIconPositions = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _SystemIcon = _interopRequireDefault(require("../../../protons/icons/SystemIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      padding: 0,
      height: "auto",
      color: theme.palette.grey[800],
      "&:hover": {
        backgroundColor: "transparent",
        "& .MuiButton-label": {
          color: theme.palette.primary.main,
          "& .text:after": {
            opacity: 1,
            backgroundColor: theme.palette.primary.main
          }
        }
      },
      "&:visited": {
        color: "transparent",
        "& .MuiButton-label": {
          color: theme.palette.info.main
        }
      },
      "&:focus": {
        backgroundColor: "transparent",
        "& .MuiButton-label": {
          color: theme.palette.secondary.main
        }
      },
      "& .MuiButton-label": {
        transition: theme.transitions.create(["color"], {
          duration: theme.transitions.duration.standard
        }),
        "& .text": {
          position: "relative",
          "&:after": {
            opacity: 0,
            content: "''",
            position: "absolute",
            left: 0,
            bottom: -1,
            right: 0,
            height: 1,
            backgroundColor: "transparent",
            transition: theme.transitions.create(["background-color", "opacity"], {
              duration: theme.transitions.duration.standard
            })
          }
        }
      },
      "& .Mui-disabled": {
        color: theme.palette.grey[500]
      }
    }
  };
});

var iconProps = function iconProps(_ref) {
  var icon = _ref.icon,
      iconPos = _ref.iconPos,
      disabled = _ref.disabled;
  if (icon && iconPos === "start") return {
    startIcon: /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
      icon: icon,
      color: "grey",
      disabled: disabled
    })
  };
  if (icon && iconPos === "end") return {
    endIcon: /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
      icon: icon,
      color: "grey",
      disabled: disabled
    })
  };
  return null;
};
/**
 * ** Buttons allow users to take actions, and make choices, with a single tap.**
 *
 */


var ButtonText = function ButtonText(_ref2) {
  var disabled = _ref2.disabled,
      action = _ref2.action,
      icon = _ref2.icon,
      iconPos = _ref2.iconPos,
      title = _ref2.title;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Button, _extends({
    className: (0, _classnames.default)(_defineProperty({}, styles.root, true)),
    onClick: function onClick(event) {
      return action(event);
    }
  }, iconProps({
    icon: icon,
    iconPos: iconPos,
    disabled: disabled
  }), {
    disableElevation: true,
    disableRipple: true,
    disableFocusRipple: true,
    disableTouchRipple: true,
    disabled: disabled
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "text"
  }, title));
};

ButtonText.propTypes = {
  /** The title of the button */
  title: _propTypes.default.string.isRequired,

  /** Disable state of the button */
  disabled: _propTypes.default.bool,

  /** The icon key from SystemIcons for the button */
  icon: _propTypes.default.string,

  /** The icon position of the button */
  iconPos: _propTypes.default.oneOf(['start', 'end']),

  /** Action that will coled on click */
  action: _propTypes.default.func.isRequired
};
ButtonText.defaultProps = {
  iconPos: "start",
  disabled: false,
  icon: null
};
var buttonTextIconPositions = ["start", "end"];
exports.buttonTextIconPositions = buttonTextIconPositions;
var _default = ButtonText;
exports.default = _default;